import {
    GET_USER_INFO, GET_MY_COMMUNITIES_AND_CATEGORY,
    IS_LOADING_GET_MY_COMMUNITIES_AND_CATEGORY, GET_USER_POSTS, SEE_FRIEND_REQUESTS, SEE_FRIEND_LIST, SEE_BLOCKED_FRIEND_LIST, SEE_FOLLOWING_LIST,
    SEE_FOLLOWERS_LIST, IS_LOADING_FRIENDS, ACCEPT_FRIEND_REQUEST, CANCEL_FRIEND_REQUEST, IS_LOADING_FRIEND_LIST, DELETE_FRIEND,
    BLOCK_FRIEND, IS_LOADING_BLOCKED_FRIEND_LIST, UNBLOCK_FRIEND, IS_LOADING_FOLLOWING_LIST, UNFOLLOW_USER, IS_LOADING_FOLLOWERS_LIST,
    IS_LOADING_DATA_PROFILE, ADD_COUNT_COMMENT_POST_PROFILE, IS_LOADING_ADD_COUNT_COMMENT_POST_PROFILE, DELETE_COUNT_COMMENT_POST_PROFILE,
    ADD_LIKE_POST_PROFILE, REMOVE_LIKE_POST_PROFILE, IS_LOADING_LIKE_POST_PROFILE, GET_RELATION_BETWEEN, LOAD_RELATION_BETWEEN,
    CHANGE_RELATION_BETWEEN, IS_LOADING_GET_USER_INFO, DELETE_POST, IS_LOADING_POSTS, GET_USER_ALBUMS, IS_LOADING_GET_USER_ALBUMS,
    GET_ALBUM_INFO, DELETE_ALBUM, POST_ALBUM_INFO, IS_LOADING_POST_ALBUM, GET_TYPE_OF_REPORT, IS_LOADING_GET_TYPE_OF_REPORT, BACK_TO_VIEW_ALBUMS,
    IS_LOADING_GET_MY_ROOMS, DELETE_ADMIN_ROOM, GET_MY_ROOMS, GET_ROOM_INFO, IS_LOADING_GET_MEMBERS_ROOM, GET_MEMBERS_ROOM, IS_LOADING_GET_ALL_ROOMS,
    GET_ALL_ROOMS, IS_LOADING_GET_MY_COMMUNITIES, GET_MY_COMMUNITIES, DELETE_MY_COMMUNITY, GET_COMMUNITY_INFO, IS_LOADING_GET_COMMUNITY_REQUESTS,
    GET_COMMUNITY_REQUESTS, ACCEPT_COMMUNITY_REQUEST, CANCEL_COMMUNITY_REQUEST, GET_COMMUNITY_MEMBERS, IS_LOADING_GET_COMMUNITY_MEMBERS, IS_LOADING_GET_COMMUNITY_MEMBERS_REJECTED,
    GET_COMMUNITY_MEMBERS_REJECTED, IS_LOADING_GET_ROOM_REQUESTS, GET_ROOM_REQUESTS, IS_LOADING_GET_USER_REQUESTS_FROM_ROOM, GET_USER_REQUESTS_FROM_ROOM, REMOVE_ROOM_REQUEST,
    DELETE_ROOM, IS_LOADING_GET_ROOMS_I_BELONG, GET_ROOMS_I_BELONG, REMOVE_REQUEST_FROM_ROOM, IS_LOADING_COMMUNITY_BY_CATEGORIES, COMMUNITIES_BY_CATEGORY, REMOVE_COMMUNITY_MEMBER,
    BLOCK_COMMUNITY_USER, IS_LOADING_GET_COMMUNITY_MEMBERS_BLOCKED, GET_COMMUNITY_MEMBERS_BLOCKED, IS_LOADING_LIST_MY_POST_REPORTED, LIST_MY_POST_REPORTED, IS_LOADING_POST_INFO,
    POST_INFO, CHANGE_MY_POST_REPORTED, IS_LOADING_LIST_POST_I_REPORTED_FROM_LIST, LIST_POST_I_REPORTED, CANCEL_POST_I_REPORTED_FROM_LIST, IS_LOADING_CLASSIFIED_INFO, CLASSIFIED_INFO,
    IS_LOADING_LOCATION_COUNTRY, LOCATION_COUNTRY, IS_LOADING_LOCATION_CITIES, LOCATION_CITIES, IS_LOADING_LOCATION_STATE, LOCATION_STATE, IS_LOADING_GET_MY_ROOMS_AND_CATEGORY, GET_MY_ROOMS_AND_CATEGORY, IS_LOADING_LIST_CLASSIFIEDS,
    LIST_CLASSIFIEDS, IS_LOADING_LIST_CLASSIFIED_SAVED, LIST_CLASSIFIED_SAVED, IS_LOADING_LIST_POST_SAVED, LIST_POST_SAVED, REMOVE_CLASSIFIED_SAVED, REMOVE_POST_SAVED, DELETE_CLASSIFIED,
    IS_LOADING_SELLER_RATE, SELLER_RATE, IS_LOADING_CLASSIFIEDS_IMAGES, CLASSIFIED_IMAGES, DELETE_CLASSIFIED_IMAGE, IS_LOADING_USER_CHALLENGES, USER_CHALLENGES, IS_LOADING_USER_BADGES, USER_BADGES, IS_LOADING_LIST_CLASSIFIEDS_OTHERS, LIST_CLASSIFIEDS_OTHERS,
    LIST_PQRS_USER, CREATE_PQRS_USER, IS_LOADING_LIST_PQRS_USER, IS_LOADING_PAYMENT_USER, PAYMENT_USER, IS_LOADING_LIST_POST_PENDING_COMMUNITY, LIST_POST_PENDING_COMMUNITY, CHANGE_STATUS_PENDING_COMMUNITY, IS_LOADING_BLOCK_VENDOR_LIST, BLOCK_VENDOR_LIST,
    UNBLOCK_VENDOR, IS_LOADING_STORIES_LIST, STORIES_LIST, IS_LOADING_CREATE_STORY, CREATE_STORY, DELETE_STORY, IS_LOADING_ARCHIVED_STORIES_LIST, ARCHIVED_STORIES_LIST, IS_LOADING_LIST_COMMUNITY_I_REPORTED_FROM_LIST, CANCEL_COMMUNITY_I_REPORTED_FROM_LIST,
    IS_LOADING_LIST_COMMUNITY_I_REPORTED, CANCEL_COMMUNITY_I_REPORTED, COMMUNITY_I_REPORTED_LIST, CHANGE_STATUS_COMMUNITY_REPORTED, IS_LOADING_MY_LIST_COMMUNITY_REPORTED, MY_LIST_COMMUNITY_REPORTED, DISABLE_PQRS_USER, IS_LOADING_USER_RANKING, USER_RANKING, IS_LOADING_GET_ALBUM_INFO,
    PROFESSIONAL_IS_LOADING_DATA_PROFILE, PROFESSIONAL_GET_USER_POSTS, PROFESSIONAL_DELETE_POST, ASIGN_MANAGER_TYPE, UNBLOCK_COMMUNITY_MEMBER, IS_LOADING_PRIVATE_USER_INFO, UPDATE_PRIVATE_USER_INFO, IS_LOADING_STORY_INFO, STORY_INFO, IS_NOT_LOADING_GET_USER_ALBUMS, IS_LOADING_LIKE_POST, ADD_LIKE_POST, UN_ARCHIVED_STORY, CLEAR_POST_INFO, CLEAR_FRIEND_LIST, ADD_FRIEND, GET_PROFILE_INFO, ADD_TO_ROOMS_I_BELONG, CLEAR_ROOM_INFO, DELETE_MEMBER_ROOM, IS_LOADING_GET_ROOM_INFO, ERROR_GET_ROOM_INFO, IS_LOADING_GET_COMMUNITY_INFO, ERROR_GET_COMMUNITY_INFO, CHECK_USER_IN_COMMUNITY, LOADING_CHECK_USER_IN_COMMUNITY, LOADING_CHECK_USER_IN_ROOM, CHECK_USER_IN_ROOM, CLEAR_POST_ALBUM_INFO, CLEAR_POST_ALBUMS, GET_ALL_ROOMS_FILTER, LOAD_STIKERS, GET_STIKERS, GET_ZONE_POSTS, ADD_ZONE_POSTS, LOAD_ZONE_POSTS, ADD_ZONE_POSTS_ERROR, CLEAR_GET_COMMUNITY_INFO, CLEAR_USER_IN_COMMUNITY, ADD_COUNT_SHARED_POST_PROFILE
} from '../actions/types'
import { GET_RANK_AVANCE } from '../admin/actions/types'
import localStorage from '../utils/hooks/useLocalStorage'

const initialState = {
    franchiseCampaigns: [],
    userProfileInfo: {},
    userProfileCount: {},
    userInfo: {},
    userCount: {},
    userPosts: [],
    loadingZonePost: false,
    loadingNewZonePosto: false,
    zonePosts: [],
    userPostsProfessional: {},
    userPostsHome: {},
    userFriendRequests: null,
    friendList: [],
    blockedFriendList: null,
    followingList: null,
    followersList: null,
    relationBetween: {},
    isLoadingFriendRequestList: true,
    isLoadingFriendList: true,
    isLoadingBlockedFriendList: true,
    isLoadingFollowingList: true,
    isLoadingFollowersList: true,
    isLoadingProfile: true,
    isLoadingProfileProfessional: true,
    isLoadingLikePost: false,
    isLoadingRelationBetween: false,
    isLoadingAddCountCommentPostProfile: false,
    isLoadingGetUserInfo: true,
    isLoadingPost: false,
    userAlbums: [],
    isLoadingGetUserAlbums: true,
    albumInfo: {},
    isLoadingAlbumInfo: true,
    albumPosts: [],
    isLoadingAlbumPosts: true,
    typeOfReports: [],
    isLoadingTypeOfReports: false,
    isLoadingMyRooms: true,
    myRoomsAdmin: [],
    loadingInRoom: false,
    inRoom: {
        is: false
    },
    roomInfo: {},
    isLoadingMembersRoom: false,
    membersRoom: [],
    isLoadingAllRooms: false,
    allRooms: [],
    allRoomsFilter: [],
    isLoadingListMyCommunities: false,
    listOfMyCommunities: [],
    isLoadingCommunity: false,
    communityInfo: {},
    loadingInComunity: false,
    inCommunity: null,
    communitysAndCategorys: [],
    isLoadingListMyCommunitiesAndCategory: true,
    isLoadingMyCommunityRequests: false,
    communityRequests: [],
    isLoadingCommunityMembers: false,
    communityMembers: [],
    isLoadingCommunityMembersRejected: false,
    communityMembersRejected: [],

    isLoadingRoomRequest: false,

    isLoadingRoom: false,
    isLoadingZone: false,
    roomRequests: [],
    isLoadingUserRequestFromRoom: false,
    userRequestsFromRoom: [],
    isLoadingRoomsIBelong: false,
    roomsIBelong: [],
    communitiesByCategory: [],
    isLoadingCommunitiesByCategory: false,
    isLoadingCommunityMembersBlocked: false,
    listCommunityMembersBlocked: [],
    roomsAndCategorys: [],
    isLoadingListMyRoomsAndCategory: true,
    isLoadingMyListPostReported: false,
    myListPostReported: [],
    isLoadingPostInfo: true,
    postInfo: {},
    isLoadingPostIReported: false,
    postListIReported: [],
    isLoadingClassifiedInfo: false,
    classifiedInfo: [],
    isLoadingListOthersClassifieds: false,
    listOthersClassifieds: [],
    isLoadingLocationCountry: false,
    isLoadingLocationState: false,
    isLoadingLocationCities: false,
    locationCities: [],
    locationCountry: [],
    locationState: [],
    isLoadingListClassifieds: false,
    listClassifieds: [],
    isLoadingListClassifiedSaved: true,
    isLoadingListPostSaved: true,
    listClassifiedSaved: [],
    listPostSaved: [],
    isLoadingSellerRate: true,
    sellerRate: {},
    isLoadingListClassifiedsImage: false,
    listClassifiedsImages: [],
    isLoadingListUserChallenges: false,
    isLoadingListUserBadges: false,
    listUserChallenges: [],
    listUserBadges: [],
    isLoadingListPQRSUser: false,
    listPQRSUser: [],
    isLoadingPaymentUser: false,
    paymentUser: [],
    isLoadingBlockVendorList: false,
    blockVendorList: [],
    storiesHomeList: [],
    isLoadingStoriesHomeList: true,
    newStory: {},
    isLoadingArchivedStoriesList: true,
    archivedStoriesList: [],
    isLoadingCommunityIReportedList: false,
    communityIReportedList: [],
    isLoadingMyCommunityReported: false,
    myCommunityReported: [],
    isLoadingUserRanking: false,
    userRanking: [],
    isLoadingPrivacyUser: false,
    privacyUser: {},
    isLoadingStoryInfo: false,
    storyInfo: {},
    usersToAdminZone: [],
    userRank: [],
    loadStikers: false,
    ecoStikers: []


}

export default function (state = initialState, action) {
    switch (action.type) {
        case "CHANGE_USER_PICTURE":
            let userProfileInfoImg = state.userProfileInfo
            if (state.userProfileInfo?._id === action.payload._id) {
                userProfileInfoImg.picture = action.payload.picture
            }
            return {
                ...state, userProfileInfo: {
                    ...state.userProfileInfo, picture: action.payload.picture,
                }, userInfo: {
                    ...state.userInfo, picture: action.payload.picture,
                }
            }
        case ADD_ZONE_POSTS_ERROR:
            return { ...state, loadingZonePost: false, loadingNewZonePost: false }
        case LOAD_ZONE_POSTS:
            return { ...state, loadingZonePost: true, loadingNewZonePost: true }
        case ADD_ZONE_POSTS:
            return { ...state, zonePosts: [action.payload, ...state.zonePosts], loadingZonePost: false, loadingNewZonePost: false }
        case GET_ZONE_POSTS:
            return { ...state, zonePosts: action.payload }
        case LOAD_STIKERS:
            return { ...state, loadStikers: true }
        case GET_STIKERS:
            return { ...state, ecoStikers: action.payload }
        case "GET_CAMPAIGNS_FRANCHISEE":
            return { ...state, franchiseCampaigns: action.payload }
        case "GET_USERS_TO_ADMIN_ZONE":
            return { ...state, usersToAdminZone: action.payload }
        case "CLEAR_USERS_TO_ADMIN_ZONE":
            return { ...state, usersToAdminZone: [] }
        case IS_LOADING_DATA_PROFILE:
            return { ...state, isLoadingProfile: true }
        case GET_USER_POSTS:
            console.log()
            return { ...state, userPosts: action.payload, isLoadingProfile: false }
        case "ADD_POST_USER":
            let addPost = state.userPosts
            if (true) {
                addPost.unshift(action.payload)
            }

            return { ...state, userPosts: addPost, isLoadingProfile: false }
        case DELETE_POST:
            var deletePost = state.userPosts.filter(post => post._id !== action.payload)

            return { ...state, userPosts: deletePost, isLoadingProfile: false }
        case PROFESSIONAL_IS_LOADING_DATA_PROFILE:
            return { ...state, isLoadingProfileProfessional: true }
        case PROFESSIONAL_GET_USER_POSTS:
            return { ...state, userPostsProfessional: action.payload, isLoadingProfileProfessional: false }
        case PROFESSIONAL_DELETE_POST:
            var deletePost = state.userPostsProfessional
            deletePost.splice(action.payload, 1)
            return { ...state, userPostsProfessional: deletePost, isLoadingProfileProfessional: false }
        case GET_USER_INFO:
            return { ...state, userInfo: action.payload.user, reported: action.payload.reported, isLoadingGetUserInfo: false }
        case GET_USER_INFO:
            return { ...state, userInfo: action.payload.user, reported: action.payload.reported, isLoadingGetUserInfo: false }
        case "SET_USER_INFO":
            delete action?.payload?.authRequestID
            delete action?.payload?.franchiseID
            delete action?.payload?.representativeID

            return {
                ...state, userInfo: {
                    ...state.userInfo,
                    ...action.payload
                }
            }
        case "GET_USER_INFO_COUNTER":
            return { ...state, userCount: action.payload.counters }
        case ADD_FRIEND:
            const countFriends = state.userProfileCount.countFriends ? state.userProfileCount.countFriends : 0;
            return { ...state, userProfileCount: { ...state.userProfileCount, countFriends: countFriends + 1 } }
        case "GET_PROFILE_INFO_COUNTER":
            return { ...state, userProfileCount: action.payload.counters }
        case GET_PROFILE_INFO:
            return { ...state, userProfileInfo: action.payload.user, reported: action.payload.reported, isLoadingGetUserInfo: false }
        case IS_LOADING_PRIVATE_USER_INFO:
            return { ...state, isLoadingPrivacyUser: true }
        case UPDATE_PRIVATE_USER_INFO:
            return { ...state, privacyUser: false }
        case IS_LOADING_GET_USER_INFO:
            return { ...state, isLoadingGetUserInfo: true }
        case IS_LOADING_POSTS:
            return { ...state, isLoadingPost: true }
            case ADD_COUNT_SHARED_POST_PROFILE:
                var postInfo = state.postInfo[0]
                return {
                    ...state, postInfo: [{ ...state.postInfo[0], shareds: postInfo.shareds + 1 }]
    
                    , isLoadingAddCountCommentPostProfile: false
                }
        case ADD_COUNT_COMMENT_POST_PROFILE:
            var postInfo = state.postInfo[0]
            return {
                ...state, postInfo: [{ ...state.postInfo[0], comments: postInfo.comments + 1 }]

                , isLoadingAddCountCommentPostProfile: false
            }
        case DELETE_COUNT_COMMENT_POST_PROFILE:
            var currentPosts = state.userPosts
            currentPosts.map((post) => {
                if (post._id === action.payload) {
                    post.comments -= 1
                }
            })
            return { ...state, userPosts: currentPosts, isLoadingAddCountCommentPostProfile: false }
        case IS_LOADING_ADD_COUNT_COMMENT_POST_PROFILE:
            return { ...state, isLoadingAddCountCommentPostProfile: true }
        case IS_LOADING_FRIENDS:
            return { ...state, isLoadingFriendRequestList: true }
        case IS_LOADING_FRIEND_LIST:
            return { ...state, isLoadingFriendList: true }
        case IS_LOADING_BLOCKED_FRIEND_LIST:
            return { ...state, isLoadingBlockedFriendList: true }
        case IS_LOADING_FOLLOWING_LIST:
            return { ...state, isLoadingFollowingList: true }
        case IS_LOADING_FOLLOWERS_LIST:
            return { ...state, isLoadingFollowersList: true }
        case SEE_FRIEND_REQUESTS:
            return { ...state, userFriendRequests: action.payload, isLoadingFriendRequestList: false }
        case ACCEPT_FRIEND_REQUEST:
            var acceptFriend = state.userFriendRequests.filter(([id]) => { return id != action.payload })
            //     delete acceptFriend[action.payload]
            return { ...state, isLoadingFriendRequestList: false, userFriendRequests: acceptFriend }
        case CANCEL_FRIEND_REQUEST:
            var cancelFriend = state.userFriendRequests.filter(([id]) => { return id != action.payload })
            // delete cancelFriend[action.payload]
            return { ...state, isLoadingFriendRequestList: false, userFriendRequests: cancelFriend }
        case DELETE_FRIEND:
            var deleteFriend = state.friendList.filter(([id]) => { return id != action.payload })
            // deleteFriend.filter(([id])=>id!==action.payload)
            return { ...state, isLoadingFriendList: false, friendList: deleteFriend }
        case BLOCK_FRIEND:
            var deleteFriend = state.friendList//.filter(([id])=>{return id !=action.payload})
            deleteFriend.map(([id, { user, social }]) => {
                if (id === action.payload) {
                    social.isBlockerSecond = true
                }
            })
            return { ...state, isLoadingFriendList: false, friendList: deleteFriend }
        case UNBLOCK_FRIEND:
            var deleteFriend = state.friendList//.filter(([id])=>{return id !=action.payload})
            deleteFriend.map(([id, { user, social }]) => {
                if (id === action.payload) {
                    social.isBlockerSecond = false
                }
            })
            return { ...state, isLoadingFriendList: false, friendList: deleteFriend }
        case UNFOLLOW_USER:
            var unfollowFriend = state.followingList.filter(([id]) => { return id != action.payload })
            // delete unfollowFriend[action.payload]
            return { ...state, isLoadingFollowingList: false, followingList: unfollowFriend }
        case CLEAR_FRIEND_LIST:
            return { ...state, friendList: [], isLoadingFriendList: true }
        case SEE_FRIEND_LIST:
            return { ...state, friendList: action.payload, isLoadingFriendList: false }
        case SEE_BLOCKED_FRIEND_LIST:
            return { ...state, blockedFriendList: action.payload, isLoadingBlockedFriendList: false }
        case SEE_FOLLOWING_LIST:
            return { ...state, followingList: action.payload, isLoadingFollowingList: false }
        case SEE_FOLLOWERS_LIST:
            return { ...state, followersList: action.payload, isLoadingFollowersList: false }
        case IS_LOADING_LIKE_POST_PROFILE:
            return { ...state, isLoadingLikePost: true }
        case ADD_LIKE_POST_PROFILE:
            var currentPosts = state.userPosts
            currentPosts.map((post) => {
                if (post._id === action.payload.contentID) {
                    post.reactions = action.payload.value
                }
            })
            return { ...state, userPosts: currentPosts, isLoadingLikePost: false }
        case REMOVE_LIKE_POST_PROFILE:
            var currentPosts = state.userPosts
            currentPosts.map((post) => {
                if (post._id === action.payload.contentID) {
                    post.likes -= action.payload.value
                    if (post.myReaction)
                        post.myReaction.value = 0
                }
            })
            return { ...state, userPosts: currentPosts, isLoadingLikePost: false }
        case GET_RELATION_BETWEEN:
            return { ...state, relationBetween: action.payload, isLoadingRelationBetween: false }
        case LOAD_RELATION_BETWEEN:
            return { ...state, isLoadingRelationBetween: true }
        case CHANGE_RELATION_BETWEEN:
            return { ...state, relationBetween: action.payload, isLoadingRelationBetween: false }
        case GET_USER_ALBUMS:
            var albums = action.payload.data
            if (action.payload.id === localStorage().getItem('idProfile'))
                albums.unshift({ newpost: true })
            return { ...state, userAlbums: albums, isLoadingGetUserAlbums: false }
        case IS_LOADING_GET_USER_ALBUMS:
            return { ...state, isLoadingGetUserAlbums: true }
        case IS_NOT_LOADING_GET_USER_ALBUMS:
            return { ...state, isLoadingGetUserAlbums: false }
        case IS_LOADING_GET_ALBUM_INFO:
            return { ...state, isLoadingAlbumInfo: true }
        case GET_ALBUM_INFO:
            return { ...state, albumInfo: action.payload, isLoadingAlbumInfo: false }
        case DELETE_ALBUM:

            var deleteAlbum = state.userAlbums.filter(album => album._id !== action.payload)


            return { ...state, isLoadingGetUserAlbums: false, userAlbums: deleteAlbum }
        case POST_ALBUM_INFO:
            var albums = action.payload.data
            if (action.payload.id === localStorage().getItem('idProfile'))
                albums.unshift({ newpost: true })

            return { ...state, albumPosts: albums, isLoadingAlbumPosts: false }
        case CLEAR_POST_ALBUM_INFO:

            return { ...state, albumPosts: [], isLoadingAlbumPosts: false }
        case CLEAR_POST_ALBUMS:
            return { ...state, userAlbums: [], isLoadingGetUserAlbums: false }
        case BACK_TO_VIEW_ALBUMS:
            return { ...state, isLoadingAlbumPosts: true }
        case IS_LOADING_POST_ALBUM:
            return { ...state, isLoadingAlbumPosts: true }
        case GET_TYPE_OF_REPORT:
            return { ...state, typeOfReports: action.payload, isLoadingTypeOfReports: false }
        case IS_LOADING_GET_TYPE_OF_REPORT:
            return { ...state, isLoadingTypeOfReports: true }
        case IS_LOADING_LIST_MY_POST_REPORTED:
            return { ...state, isLoadingMyListPostReported: true }
        case CHANGE_MY_POST_REPORTED:
            console.log()
            if (action.payload.changeReport.reportState === 2) {
                var removePostReported = state.myListPostReported
                removePostReported.splice(action.payload.index, 1)
            }
            if (action.payload.changeReport.reportState === 3) {
                var removePostReported = state.myListPostReported
                removePostReported.splice(action.payload.index, 1, action.payload.changeReport)
            }
            return { ...state, isLoadingMyListPostReported: false, myListPostReported: removePostReported }

        case LOADING_CHECK_USER_IN_ROOM:
            return { ...state, loadingInRoom: true }
        case CHECK_USER_IN_ROOM:
            return { ...state, inRoom: action.payload, loadingInRoom: false }
        case LIST_MY_POST_REPORTED:
            return { ...state, isLoadingMyListPostReported: false, myListPostReported: action.payload }
        case IS_LOADING_GET_MY_ROOMS:
            return { ...state, isLoadingMyRooms: true }
        case GET_MY_ROOMS:
            return { ...state, isLoadingMyRooms: false, myRoomsAdmin: action.payload }
        case DELETE_ADMIN_ROOM:
            var deleteAdminRoom = Array.from(state.myRoomsAdmin).map(room => room._id !== action.payload)
            console.log()

            return { ...state, isLoadingMyRooms: false, myRoomsAdmin: deleteAdminRoom }
        case IS_LOADING_GET_ROOMS_I_BELONG:
            return { ...state, isLoadingRoomsIBelong: true }
        case ADD_TO_ROOMS_I_BELONG:
            const roomsIBelong = Array.from(state.roomsIBelong)
            roomsIBelong.push(action.payload)
            return { ...state, isLoadingRoomsIBelong: false, roomsIBelong: roomsIBelong }
        case GET_ROOMS_I_BELONG:
            return { ...state, isLoadingRoomsIBelong: false, roomsIBelong: action.payload }
        case DELETE_ROOM:
            var deleteRoomMember = Array.from(state.myRoomsAdmin)
            console.log()
            deleteRoomMember.splice((action.payload), 1)
            return { ...state, isLoadingRoomsIBelong: false, roomsIBelong: deleteRoomMember }
        case IS_LOADING_GET_ROOM_INFO:
            return { ...state, isLoadingRoom: true }
        case GET_ROOM_INFO:
            return { ...state, roomInfo: action.payload, isLoadingRoom: false }
        case ERROR_GET_ROOM_INFO:
            return { ...state, roomInfo: { isError: true }, isLoadingRoom: false }
        case CLEAR_ROOM_INFO:
            return { ...state, roomInfo: {} }
        case IS_LOADING_GET_MEMBERS_ROOM:
            return { ...state, isLoadingMembersRoom: true }
        case GET_MEMBERS_ROOM:
            return { ...state, isLoadingMembersRoom: false, membersRoom: action.payload }
        case DELETE_MEMBER_ROOM:
            const membersRoom = state.membersRoom.filter(member => member._id !== action.payload)
            return { ...state, isLoadingMembersRoom: false, membersRoom: membersRoom }
        case IS_LOADING_GET_ALL_ROOMS:
            return { ...state, isLoadingAllRooms: true }
        case GET_ALL_ROOMS_FILTER:
            return { ...state, isLoadingAllRooms: false, allRoomsFilter: action.payload }
        case GET_ALL_ROOMS:
            return { ...state, isLoadingAllRooms: false, allRooms: action.payload }
        case IS_LOADING_GET_MY_COMMUNITIES:
            return { ...state, isLoadingListMyCommunities: true }
        case GET_MY_COMMUNITIES:
            return { ...state, isLoadingListMyCommunities: false, listOfMyCommunities: action.payload }
        case DELETE_MY_COMMUNITY:
            var deleteMyCommunity = state.communitysAndCategorys.filter(zone => zone._id !== action.payload)
            return { ...state, isLoadingListMyCommunitiesAndCategory: false, communitysAndCategorys: deleteMyCommunity }
        case IS_LOADING_GET_MY_COMMUNITIES_AND_CATEGORY:
            return { ...state, isLoadingListMyCommunitiesAndCategory: true }
        case GET_MY_COMMUNITIES_AND_CATEGORY:
            return { ...state, isLoadingListMyCommunitiesAndCategory: false, communitysAndCategorys: action.payload }
        case IS_LOADING_GET_MY_ROOMS_AND_CATEGORY:
            return { ...state, isLoadingListMyRoomsAndCategory: true }
        case GET_MY_ROOMS_AND_CATEGORY:
            return { ...state, isLoadingListMyRoomsAndCategory: false, roomsAndCategorys: action.payload }
        case IS_LOADING_GET_COMMUNITY_INFO:
            return { ...state, isLoadingCommunity: true }
        case GET_COMMUNITY_INFO:
            return { ...state, communityInfo: action.payload, isLoadingCommunity: false }

        case LOADING_CHECK_USER_IN_COMMUNITY:
            return { ...state, loadingInComunity: true }
        case CHECK_USER_IN_COMMUNITY:
            return { ...state, inCommunity: action.payload, loadingInComunity: false }
        case CLEAR_USER_IN_COMMUNITY:
            return { ...state, inCommunity: null, loadingInComunity: false }

        case ERROR_GET_COMMUNITY_INFO:
            return { ...state, communityInfo: { isError: true }, isLoadingCommunity: false }


        case IS_LOADING_GET_COMMUNITY_REQUESTS:
            return { ...state, isLoadingMyCommunityRequests: true }
        case GET_COMMUNITY_REQUESTS:
            return { ...state, isLoadingMyCommunityRequests: false, communityRequests: action.payload }
        case ACCEPT_COMMUNITY_REQUEST:
            var deleteCommunityRequest = state.communityRequests.filter(request => request._id !== action.payload)
            return { ...state, isLoadingMyCommunityRequests: false, communityRequests: deleteCommunityRequest }
        case CANCEL_COMMUNITY_REQUEST:
            var deleteCommunityRequest = state.communityRequests
            console.log()
            deleteCommunityRequest.splice((action.payload), 1)
            return { ...state, isLoadingMyCommunityRequests: false, communityRequests: deleteCommunityRequest }
        case IS_LOADING_GET_COMMUNITY_MEMBERS:
            return { ...state, isLoadingCommunityMembers: true }
        case ASIGN_MANAGER_TYPE:
            var newCommunityMembers = state.communityMembers
            if (action.payload.dataType)
                newCommunityMembers[action.payload.index].typeId = action.payload.dataType
            else
                delete newCommunityMembers[action.payload.index].typeId
            console.log()
            return { ...state, communityMembers: newCommunityMembers, isLoadingCommunityMembers: false }
        case GET_COMMUNITY_MEMBERS:
            return { ...state, communityMembers: action.payload, isLoadingCommunityMembers: false }

        case IS_LOADING_GET_COMMUNITY_MEMBERS_REJECTED:
            return { ...state, isLoadingCommunityMembersRejected: true }
        case GET_COMMUNITY_MEMBERS_REJECTED:
            return { ...state, communityMembersRejected: action.payload, isLoadingCommunityMembersRejected: false }
        case IS_LOADING_GET_ROOM_REQUESTS:
            return { ...state, isLoadingRoomRequest: true }
        case GET_ROOM_REQUESTS:
            return { ...state, isLoadingRoomRequest: true, roomRequests: action.payload }
        case REMOVE_ROOM_REQUEST:
            var deleteRoomRequest = state.roomRequests.filter(request => request._id != action.payload)


            return { ...state, isLoadingRoomRequest: false, roomRequests: deleteRoomRequest }
        case BLOCK_COMMUNITY_USER:
            if (action.payload.fromWhere === 'membersCommunity') {
                var removeCommunityMember = state.communityMembers
                console.log()
                removeCommunityMember.splice((action.payload.index), 1)
                return { ...state, isLoadingCommunityMembers: false, communityMembers: removeCommunityMember }
            }
            if (action.payload.fromWhere === 'membersRejected') {
                var removeCommunityMember = state.communityMembersRejected
                console.log()
                removeCommunityMember.splice((action.payload.index), 1)
                return { ...state, isLoadingCommunityMembersRejected: false, communityMembersRejected: removeCommunityMember }
            }

        case UNBLOCK_COMMUNITY_MEMBER:
            var removeCommunityMemberBlocked = state.listCommunityMembersBlocked
            console.log()
            removeCommunityMemberBlocked.splice((action.payload.index), 1)
            return { ...state, isLoadingCommunityMembersBlocked: false, listCommunityMembersBlocked: removeCommunityMemberBlocked }

        case REMOVE_COMMUNITY_MEMBER:
            var removeCommunityMember = state.communityMembers.filter(member => member._id != action.payload)
            return { ...state, isLoadingCommunityMembers: false, communityMembers: removeCommunityMember }

        /*   if (action.payload.fromWhere === 'membersCommunity') {
              var removeCommunityMember = state.communityMembers
              console.log()
              removeCommunityMember.splice((action.payload.index), 1)
              return { ...state, isLoadingCommunityMembers: false, communityMembers: removeCommunityMember }
          }
          if (action.payload.fromWhere === 'membersRejected') {
              var removeCommunityMember = state.communityMembersRejected
              console.log()
              removeCommunityMember.splice((action.payload.index), 1)
              return { ...state, isLoadingCommunityMembersRejected: false, communityMembersRejected: removeCommunityMember }
          } */
        case IS_LOADING_GET_COMMUNITY_MEMBERS_BLOCKED:
            return { ...state, isLoadingCommunityMembersBlocked: true }
        case GET_COMMUNITY_MEMBERS_BLOCKED:
            return { ...state, isLoadingCommunityMembersBlocked: false, listCommunityMembersBlocked: action.payload }
        case IS_LOADING_GET_USER_REQUESTS_FROM_ROOM:
            return { ...state, isLoadingUserRequestFromRoom: true }
        case GET_USER_REQUESTS_FROM_ROOM:
            return { ...state, isLoadingUserRequestFromRoom: false, userRequestsFromRoom: action.payload }

        case REMOVE_REQUEST_FROM_ROOM:
            var deleteRequestFromRoom = state.userRequestsFromRoom.filter(request => request._id != action.payload)


            return { ...state, isLoadingUserRequestFromRoom: false, userRequestsFromRoom: deleteRequestFromRoom }
        case IS_LOADING_COMMUNITY_BY_CATEGORIES:
            return { ...state, isLoadingCommunitiesByCategory: true }
        case COMMUNITIES_BY_CATEGORY:
            return { ...state, isLoadingCommunitiesByCategory: true, communitiesByCategory: action.payload }
        case IS_LOADING_POST_INFO:
            return { ...state, isLoadingPostInfo: true }
        case POST_INFO:
            return { ...state, isLoadingPostInfo: false, postInfo: action.payload }
        case CLEAR_POST_INFO:
            return { ...state, isLoadingPostInfo: true, postInfo: {} }
        case IS_LOADING_LIKE_POST:
            return { ...state, isLoadingLikePost: true }
        case ADD_LIKE_POST: {
            let postInfo = state.postInfo[0];
            console.log();
            postInfo.reactions = action.payload.value
            return { ...state, isLoadingLikePost: false, postInfo: [postInfo] }
        }

        case IS_LOADING_LIST_POST_I_REPORTED_FROM_LIST:
            return { ...state, isLoadingLikePost: true }
        case LIST_POST_I_REPORTED:
            return { ...state, isLoadingPostIReported: false, postListIReported: action.payload }
        case CANCEL_POST_I_REPORTED_FROM_LIST:
            console.log()
            var removePostIReportedFromList = state.postListIReported
            removePostIReportedFromList.splice(action.payload, 1)
            console.log()
            return { ...state, isLoadingPostIReported: false, postListIReported: removePostIReportedFromList }


        case IS_LOADING_CLASSIFIED_INFO:
            return { ...state, isLoadingClassifiedInfo: true }
        case CLASSIFIED_INFO:
            return { ...state, isLoadingClassifiedInfo: false, classifiedInfo: action.payload }
        case IS_LOADING_LIST_CLASSIFIEDS:
            return { ...state, isLoadingListClassifieds: true }
        case LIST_CLASSIFIEDS:
            var list = action.payload
            list.unshift({ newClassified: 'NewClassified' })
            return { ...state, isLoadingListClassifieds: false, listClassifieds: list }

        case IS_LOADING_LIST_CLASSIFIEDS_OTHERS:
            return { ...state, isLoadingListOthersClassifieds: true }
        case LIST_CLASSIFIEDS_OTHERS:
            return { ...state, isLoadingListOthersClassifieds: false, listOthersClassifieds: action.payload }
        case DELETE_CLASSIFIED:
            console.log()
            var removeClassified = state.listClassifieds
            removeClassified.splice((action.payload), 1)
            console.log()
            return { ...state, isLoadingListClassifieds: false, listClassifieds: removeClassified }
        case IS_LOADING_SELLER_RATE:
            return { ...state, isLoadingSellerRate: true }
        case SELLER_RATE:
            return { ...state, isLoadingSellerRate: false, sellerRate: action.payload }
        case IS_LOADING_LOCATION_COUNTRY:
            return { ...state, isLoadingLocationCountry: true }
        case LOCATION_COUNTRY:
            return { ...state, isLoadingLocationCountry: true, locationCountry: action.payload }
        case IS_LOADING_LOCATION_STATE:
            return { ...state, isLoadingLocationState: true }
        case LOCATION_STATE:
            return { ...state, isLoadingLocationState: true, locationState: action.payload }
        case IS_LOADING_LOCATION_CITIES:
            return { ...state, isLoadingLocationCities: true }
        case LOCATION_CITIES:
            return { ...state, isLoadingLocationCities: true, locationCities: action.payload }



        case IS_LOADING_LIST_CLASSIFIED_SAVED:
            return { ...state, isLoadingListClassifiedSaved: true }
        case IS_LOADING_CLASSIFIEDS_IMAGES:
            return { ...state, isLoadingListClassifiedsImage: true }
        case CLASSIFIED_IMAGES:
            return { ...state, isLoadingListClassifiedsImage: false, listClassifiedsImages: action.payload }
        case DELETE_CLASSIFIED_IMAGE:
            var deleteImage = state.listClassifiedsImages
            console.log()
            deleteImage.splice((action.payload), 1)
            return { ...state, isLoadingListClassifiedsImage: false, listClassifiedsImages: deleteImage }
        case LIST_CLASSIFIED_SAVED:
            console.log()
            return { ...state, isLoadingListClassifiedSaved: false, listClassifiedSaved: action.payload }
        case "IS_LOADING_LIKE_POST_SAVE":
            return { ...state, isLoadingLikeSave: true }
        case "ADD_LIKE_POST_SAVE":
            console.log();
            var currentPosts = state.listPostSaved
            currentPosts.map((post) => {
                if (post.postID._id === action.payload.contentID) {
                    post.reactions = action.payload.value
                }
            })
            return { ...state, listPostSaved: currentPosts, isLoadingLikeSave: false }
        case IS_LOADING_LIST_POST_SAVED:
            return { ...state, isLoadingListPostSaved: true }
        case LIST_POST_SAVED:
            return { ...state, isLoadingListPostSaved: false, listPostSaved: action.payload }
        case REMOVE_CLASSIFIED_SAVED:
            var deleteSaved = state.listClassifiedSaved
            console.log()
            deleteSaved.splice((action.payload), 1)
            return { ...state, isLoadingListClassifiedSaved: false, listClassifiedSaved: deleteSaved }
        case REMOVE_POST_SAVED:
            var deleteSaved = state.listPostSaved
            console.log()
            deleteSaved.splice((action.payload), 1)
            return { ...state, isLoadingListPostSaved: false, listPostSaved: deleteSaved }
        case IS_LOADING_USER_CHALLENGES:
            return { ...state, isLoadingListUserChallenges: true }
        case USER_CHALLENGES:
            return { ...state, isLoadingListUserChallenges: false, listUserChallenges: action.payload }
        case IS_LOADING_USER_BADGES:
            return { ...state, isLoadingListUserBadges: true }
        case USER_BADGES:
            return { ...state, isLoadingListUserBadges: false, listUserBadges: action.payload }

        case IS_LOADING_LIST_PQRS_USER:
            return { ...state, isLoadingListPQRSUser: true }
        case LIST_PQRS_USER:
            console.log()
            return { ...state, listPQRSUser: action.payload || [], isLoadingListPQRSUser: false }
        case CREATE_PQRS_USER:
            console.log()
            var addPQRS = Array.from(state.listPQRSUser)
            addPQRS.push(action.payload)
            return { ...state, listPQRSUser: addPQRS, isLoadingListPQRSUser: false }
        case DISABLE_PQRS_USER:
            var disablePQRS = Array.from(state.listPQRSUser)
            disablePQRS.splice(action.payload, 1)
            return { ...state, isLoadingListPQRSUser: false, listPQRSUser: disablePQRS }
        case IS_LOADING_PAYMENT_USER:
            return { ...state, isLoadingPaymentUser: true }
        case PAYMENT_USER:
            return { ...state, isLoadingPaymentUser: false, paymentUser: action.payload }
        case IS_LOADING_LIST_POST_PENDING_COMMUNITY:
            return { ...state, isLoadingRequestPostCommunity: true }
        case LIST_POST_PENDING_COMMUNITY:
            console.log()
            return { ...state, isLoadingRequestPostCommunity: false, requestPostCommunityList: action.payload }
        case CHANGE_STATUS_PENDING_COMMUNITY:
            var deleteRequest = state.requestPostCommunityList
            deleteRequest.splice((action.payload), 1)
            return { ...state, isLoadingRequestPostCommunity: false, requestPostCommunityList: deleteRequest }
        case IS_LOADING_BLOCK_VENDOR_LIST:
            return { ...state, isLoadingBlockVendorList: true }
        case BLOCK_VENDOR_LIST:
            return { ...state, isLoadingBlockVendorList: false, blockVendorList: action.payload }
        case UNBLOCK_VENDOR:
            var unblockVendor = state.blockVendorList
            unblockVendor.splice((action.payload), 1)
            return { ...state, isLoadingBlockVendorList: false, blockVendorList: unblockVendor }
        case IS_LOADING_STORIES_LIST:
            return { ...state, isLoadingStoriesHomeList: true }
        case STORIES_LIST:
            return { ...state, isLoadingStoriesHomeList: false, storiesHomeList: action.payload }
        case IS_LOADING_STORY_INFO:
            return { ...state, isLoadingStoryInfo: true }
        case STORY_INFO:
            return { ...state, isLoadingStoryInfo: false, storyInfo: action.payload }
        case IS_LOADING_CREATE_STORY:
            return { ...state, isLoadingCreateStory: true }
        case CREATE_STORY:
            return { ...state, isLoadingCreateStory: false, newStory: action.payload }
        case DELETE_STORY:
            console.log()
            var deleteStory = state.storiesHomeList;
            deleteStory.ownStories = deleteStory.ownStories.filter(story => story._id !== action.payload)
            //deleteStory.splice((action.payload), 1)
            return { ...state, isLoadingStoriesHomeList: false, storiesHomeList: deleteStory }
        case IS_LOADING_ARCHIVED_STORIES_LIST:
            return { ...state, isLoadingArchivedStoriesList: true }
        case ARCHIVED_STORIES_LIST:
            return { ...state, isLoadingArchivedStoriesList: false, archivedStoriesList: action.payload }
        case UN_ARCHIVED_STORY:
            console.log()
            var deleteStory = state.archivedStoriesList.filter(story => story._id !== action.payload)
            //deleteStory.splice((action.payload), 1)
            return { ...state, isLoadingArchivedStoriesList: false, archivedStoriesList: deleteStory }
        case IS_LOADING_LIST_COMMUNITY_I_REPORTED_FROM_LIST:
            return { ...state, isLoadingCommunityIReportedList: true }
        case COMMUNITY_I_REPORTED_LIST:
            return { ...state, isLoadingCommunityIReportedList: false, communityIReportedList: action.payload || [] }
        case CANCEL_COMMUNITY_I_REPORTED_FROM_LIST:
            console.log()
            var deleteReportCommunity = state.communityIReportedList
            deleteReportCommunity.splice((action.payload), 1)
            return { ...state, isLoadingCommunityIReportedList: false, communityIReportedList: deleteReportCommunity }
        case CANCEL_COMMUNITY_I_REPORTED:
        case CHANGE_STATUS_COMMUNITY_REPORTED:
            console.log()
            var changeReportCommunity = state.myCommunityReported
            changeReportCommunity.splice((action.payload), 1)
            return { ...state, isLoadingMyCommunityReported: false, communityIReportedList: changeReportCommunity }
        case IS_LOADING_MY_LIST_COMMUNITY_REPORTED:
            return { ...state, isLoadingMyCommunityReported: true }
        case MY_LIST_COMMUNITY_REPORTED:
            return { ...state, isLoadingMyCommunityReported: false, myCommunityReported: action.payload }
        case IS_LOADING_USER_RANKING:
            return { ...state, isLoadingUserRanking: true }
        case USER_RANKING:
            return { ...state, isLoadingUserRanking: false, userRanking: action.payload }
        case GET_RANK_AVANCE:
            return { ...state, userRank: action.payload }
        default:
            return state

    }
}